import { OTA_UniqueID } from "./ota_uniqueid.model";

export class OTA_VehRetResRQCore {
    public uniqueID = new OTA_UniqueID();
}